import { render, staticRenderFns } from "./WashHistory.vue?vue&type=template&id=6aba875e&scoped=true"
import script from "./WashHistory.vue?vue&type=script&lang=js"
export * from "./WashHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba875e",
  null
  
)

export default component.exports